import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function AdminLogin({ backendUrl }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await axios.post(`${backendUrl}/api/auth/login`, { email, password }, { withCredentials: true });
      // Store token as fallback for cookie issues
      if (res.data.access_token) {
        sessionStorage.setItem("pord_admin_token", res.data.access_token);
      }
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (typeof detail === "string") setError(detail);
      else if (Array.isArray(detail)) setError(detail.map(d => d.msg || JSON.stringify(d)).join(" "));
      else setError("Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="admin-container" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} data-testid="admin-login-page">
      <div className="admin-card" style={{ maxWidth: 400, width: "100%" }}>
        <h2 className="section-heading" style={{ marginBottom: 8 }}>Pord. Admin</h2>
        <p className="muted-caption" style={{ marginBottom: 32 }}>Sign in to view signups</p>

        <form onSubmit={handleLogin}>
          <input
            className="form-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-email-input"
            style={{ marginBottom: 20 }}
          />
          <input
            className="form-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-password-input"
            style={{ marginBottom: 24 }}
          />
          {error && <p style={{ color: "#e87c7c", fontSize: "0.85rem", marginBottom: 12 }}>{error}</p>}
          <button className="cta-pill cta-pill-filled" type="submit" disabled={loading} data-testid="admin-login-btn" style={{ width: "100%", justifyContent: "center" }}>
            {loading ? "..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
